export class AuthenticationRequestBody{
    number: string;
    dateOfBirth: string;
}